import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
    selector: '[phoneInputMask]'
})
export class PhoneMaskDirective {
    private el: HTMLInputElement;
    @Input() phoneInputMask: string = '';

    constructor(private elementRef: ElementRef) {
        this.el = this.elementRef.nativeElement;
    }

    @HostListener('keyup', ['$event']) onKeyup(event: KeyboardEvent): void {
        if (event.key !== 'Backspace' && event.key !== 'Tab') {
            this.handleInput();
        }
    }

    private handleInput(): void {
        const tel = this.el.value.replace(/[^0-9]/g, '');
        const value = tel.toString().trim().replace(/^\+/, '');
        let result;

        if (value.match(/[^0-9]/)) {
            result = tel;
        }

        let city;
        let number;

        switch (value.length) {
            case 0:
            case 1:
            case 2:
                city = value;
                break;

            default:
                city = value.slice(0, 3);
                number = value.slice(3);
        }

        if (number) {
            if (number.length > 2) {
                number = number.slice(0, 3) + '-' + number.slice(3, 7);
            } else {
                number = number;
            }

            result = ('(' + city + ') ' + number).trim();
        } else {
            result = '(' + city;
        }

        this.el.value = result;
    }
}
